import { ref, onMounted, onUnmounted } from 'vue';

export const useTimer = (seconds: number, callback: () => void) => {
  const timer = ref(seconds);
  const timerId = ref<NodeJS.Timeout | null>(null);

  onMounted(() => {
    timerId.value = setInterval(() => {
      if (timer.value === 0) {
        clearInterval(timerId.value);

        callback();
      } else {
        timer.value = timer.value - 1;
      }
    }, 1000);
  });

  onUnmounted(() => {
    if (timerId.value) {
      clearInterval(timerId.value);
    }
  });

  return { timer };
};
